






















































































import { FullUser } from '@front-app/services/UserApi/UserModel';
import {
	computed,
	defineComponent,
	nextTick,
	PropType,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { v } from '@front-app/components/form/validation/useValidation';
import { requiredIfBoth, maxLen, inRange } from '@front-app/components/form/validation/validators';
import { toNegOneOrString } from '@front-app/modules/profile/util/occupation';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import EditorWrapper from '@front-app/components/layouts/form/EditorWrapper.vue';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { ApiMonthOption } from '@front-app/components/inputs/monthPickerUtil';
import MonthPicker from '@front-app/components/inputs/MonthPicker.vue';

const YEAR_MONTH_EMPTY_STATE = ApiMonthOption.NONE;

export default defineComponent({
	components: {
		FormSection,
		FormLabel,
		FormError,
		FormInput,
		EditorWrapper,
		MonthPicker,
	},
	props: {
		user: {
			type: Object as PropType<FullUser>,
			required: true,
		},
	},
	setup(props) {
		const actualPositionTitle = computed(() => props.user.currentOccupation.positionTitle);
		const positionTitle = ref('');
		watch(actualPositionTitle, (curr: string) => {
			positionTitle.value = curr;
		}, { immediate: true });

		const minYear = new Date().getFullYear() - 100;
		const maxYear = new Date().getFullYear();
		const actualStartYear = computed(() => props.user.currentOccupation.startYear);
		const startYear: Ref<number | null> = ref(null);
		watch(actualStartYear, (curr: number | null) => {
			if (!curr || curr < minYear || curr > maxYear) {
				startYear.value = null;
			} else {
				startYear.value = curr;
			}
		}, { immediate: true });

		const actualStartMonth = computed(() => props.user.currentOccupation.startMonth);
		const startMonth: Ref<number | null> = ref(null);
		watch(actualStartMonth, (curr: number | null) => {
			startMonth.value = curr;
		}, { immediate: true });

		// Validation
		const yearRangeValidator = inRange(minYear, maxYear);
		const validation = v({
			positionTitle: {
				value: positionTitle,
				rules: [maxLen(100)],
			},
			startYear: {
				value: startYear,
				rules: [
					requiredIfBoth(() => startMonth.value, [YEAR_MONTH_EMPTY_STATE]),
					yearRangeValidator,
				],
			},
		});
		const {
			focusFirstInvalid,
		} = useFocusFirstInvalidField({ containerSelector: '.current-occupation__update-form' });
		// END Validation

		const {
			track,
			isError,
			isLoading,
			isSuccess,
		} = useAsyncStatus();

		const saveUser = async () => {
			validation.validate();
			if (validation.isValid.value) {
				const currentOccupation = {
					positionTitle: positionTitle.value,
					startMonth: toNegOneOrString(startMonth.value),
					startYear: toNegOneOrString(startYear.value),
				};
				track(CurrentUserStore.actions.update({ currentOccupation }));
			} else {
				// Focus the first error field
				await nextTick();
				focusFirstInvalid();
			}
		};
		return {
			positionTitle,
			startMonth,
			startYear,
			saveUser,
			// Status
			isError,
			isLoading,
			isSuccess,
			// Validation
			minYear,
			maxYear,
			validation,
			yearRangeValidator,
			YEAR_MONTH_EMPTY_STATE,
		};
	},
});
